//定时发布灰度人员
const Timinggrayusers=[4848287,4848325,4848297,4847569,4848288,4846844,4848255,4841381,4842016]
const Repushusers=[4847276,4846844,4841381,4845994,4842016]
export default{
    Timinggrayusers,
    Repushusers
}


//////////////////
// WEBPACK FOOTER
// ./global_variable.js
// module id = null
// module chunks = 